class ArrayClass {
  // public findOneAndRemove<T>(array: T[], predicate: (item: T) => boolean): T | null {
  //   const index = array.findIndex(predicate);
  //   if (index === -1) return null;
  //   return array.splice(index, 1)[0] ?? null;
  // }

  // public findOneAndUpdate<T>(array: T[], predicate: (item: T) => boolean, item: T): T | null {
  //   const index = array.findIndex(predicate);
  //   if (index === -1) return null;
  //   return this.replaceByIndex(array, index, item);
  // }

  /** Возвращает новый массив, не изменяя текущий */
  public removeByIndex<T>(array: T[], index: number): T[] {
    const copied = [...array];
    copied.splice(index, 1);
    return copied;
  }

  /** Возвращает новый массив, не изменяя текущий */
  public findOneAndRemove<T>(
    array: T[],
    predicate: (value: T, index: number, obj: T[]) => boolean,
  ): T[] {
    const index = array.findIndex(predicate);
    return this.removeByIndex(array, index);
  }

  /** Возвращает новый массив, не изменяя текущий */
  public replaceByIndex<T>(array: T[], index: number, item: T): T[] {
    const copied = [...array];
    copied.splice(index, 1, item);
    return copied;
  }

  /** Возвращает новый массив, не изменяя текущий */
  public findOneAndReplace<T>(
    array: T[],
    item: T,
    predicate: (value: T, index: number, obj: T[]) => boolean,
  ): T[] {
    const index = array.findIndex(predicate);
    return this.replaceByIndex(array, index, item);
  }

  /** Возвращает новый массив, не изменяя текущий */
  public insertByIndex<T>(array: T[], index: number, item: T): T[] {
    const copied = [...array];
    copied.splice(index, 0, item);
    return copied;
  }

  /** Возвращает новый массив, не изменяя текущий */
  public move<T>(array: T[], indexFrom: number, indexTo: number): T[] {
    const copied = [...array];
    const item = copied.splice(indexFrom, 1)[0] ?? null;
    if (item === null) throw new Error(`Элемент по индексу ${indexFrom} не найден`);
    copied.splice(indexTo, 0, item);
    return copied;
  }
}

//

const array = new ArrayClass();
export default array;
